import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { SectionHeader } from '@/components/headings'
import Section from '@/components/section'
import config from '@/config'
import { colors } from '@/styles'

const { BACKEND_SERVER } = config

const ViewLink = styled.a`
  color: ${colors.link};
`

const TenancyAgreement = ({ contract, act }) => {
  const { t } = useTranslation()
  const titleText = act.title
  const descriptionText = act.description
  const docName = contract.state_machine === 'draft' ? 'draft' : 'contract'
  const pdfUrl = `${BACKEND_SERVER}/dynamic_contracts/view/contract/${contract.id}/${docName}.pdf`

  return (
    <Section key="tenancy-section">
      <SectionHeader>{titleText}</SectionHeader>
      <p>{descriptionText}</p>
      <ViewLink href={pdfUrl} target="_blank" rel="noopener noreferrer">
        {t('l.contract.edit.view_full_agreement.button', 'View full agreement')}
      </ViewLink>
    </Section>
  )
}

export default TenancyAgreement
